import React, {KeyboardEventHandler, useCallback, useMemo, useRef, useState} from 'react'

import EntitySelectorSearchInput from "../../../../../gd-components/entity-selector/search/search-input"
import EntitySelectorSearchRow from "../../../../../gd-components/entity-selector/search/search-row"
import Button, {ButtonSize} from "../../../../../gd-components/buttons/gd-button/gd-button-ui5-new"
import {EntitySelectorListType} from "../../../../../gd-components/entity-selector/@const"

const debug = false
// const debug = "FieldSelectTask_Popover_Search"

type Props = {
    listType            : EntitySelectorListType

    onKeyDown           : KeyboardEventHandler
    onSearchChanged     : {(value:string):void}
    onTypeChanged       : {(type:EntitySelectorListType):void}
}

// Recent / Browse as BUTTONS on the search line -- what the entity selector's
// task tab looked like before those became sub-tabs. It lives here because this
// popover is the only thing still shaped that way: it is a field editor with no
// title line to hang tabs under, and its list subtracts this row's height by
// hand (`list.tsx`), so the inset is fixed here rather than inherited.
export default function FieldSelectTask_Popover_Search (props:Props) {
    debug && console.log(debug, 'render', props)

    const [search, setSearch]   = useState('')
    const searchRef             = useRef<any>()

    const delayedSearch = useMemo(()=>_.debounce((search)=>{
        debug && console.log(debug, 'delayedSearch', search)
        props.onSearchChanged(search)
    }, 500), [])

    const onSearchChange = useCallback((value:string)=>{
        debug && console.log(debug, 'onSearchChange', value)
        setSearch(value)
        delayedSearch(value)
    }, [])

    const onSearchCancel = useCallback(()=>{
        setSearch('')
        delayedSearch('')
    }, [])

    const onChangeType = useCallback((type:EntitySelectorListType)=>{
        onSearchCancel()
        props.onTypeChanged(type)
        searchRef.current?.focus()
    }, [])

    const isRecent = !search && props.listType === EntitySelectorListType.RECENT
    const isBrowse = !search && props.listType === EntitySelectorListType.BROWSE

    return (
        <EntitySelectorSearchRow className="p-l-15 p-r-15 p-t-15 p-b-10">
            <EntitySelectorSearchInput
                ref             = {searchRef}
                search          = {search}
                placeholder     = "Search by task # or name"
                onKeyDown       = {props.onKeyDown}
                onSearchChange  = {onSearchChange}
                onSearchCancel  = {onSearchCancel}
            />

            <Button
                className   = "m-l-10 p-l-8 p-r-8"
                type        = {isRecent ? 'selected' : 'on-gray'}
                size        = {ButtonSize.SMALL}
                icon        = 'i5-recent'
                label       = 'Recent'
                onClick     = {()=>{onChangeType(EntitySelectorListType.RECENT)}}
            />

            <Button
                className   = "m-l-10 p-l-8 p-r-8"
                type        = {isBrowse ? 'selected' : 'on-gray'}
                size        = {ButtonSize.SMALL}
                icon        = 'i5-folder-tree'
                label       = 'Browse'
                onClick     = {()=>{onChangeType(EntitySelectorListType.BROWSE)}}
            />
        </EntitySelectorSearchRow>
    )
}
